"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOCAL_STORAGE_KEYS = void 0;
exports.LOCAL_STORAGE_KEYS = {
    AUTH_TOKEN: 'architect-auth-token',
    USER_ID_TOKEN: 'architect-user-id',
};
